import UsersDataTable from 'modules/Users/UsersDataTable';

import { useGetStatisticsQuery } from 'api/StatisticsEndPoints';
import { useGetUsersQuery } from 'api/UsersEndPoints';
import { useAppSelector } from 'hooks/redux';
import get from 'lodash/get';
import { UserTableModel } from 'modules/Users/DataTableDef';
import UserTableActions from 'modules/Users/UserTableActions';
import { useMemo } from 'react';
import Loader from 'shared/component/Loader';
import './users.css';

const debug = false;

const UsersPage = () => {
  const sortColumn = useAppSelector(state => state.usersTable.sortColumn);
  const sortDirection = useAppSelector(state => state.usersTable.sortDirection);
  const filter = useAppSelector(state => state.usersTable.filter);
  const { data: dataUsers, isLoading: isLoadingUsers } = useGetUsersQuery();
  const { data: statistics, isLoading: isLoadingStatistics } = useGetStatisticsQuery();

  const isLoading = isLoadingUsers || isLoadingStatistics;

  const users = dataUsers ? [...dataUsers] : [];

  const userStats = useMemo(() => {
    if (debug) {
      for (let i = 100; i < 200; i++) {
        users.push({
          id: i,
          firstName: `User${i}`,
          lastName: `Last${i}`,
          email: `email${i}@test.fr`,
          company: `Company ${i}`,
        });
      }
    }

    const filteredUsers = users.filter(user => {
      const firstName = user.firstName.toLowerCase();
      const lastName = user.lastName.toLowerCase();
      const filterValue = filter.toLowerCase();

      return firstName.includes(filterValue) || lastName.includes(filterValue);
    });

    const result = filteredUsers.reduce((acc: UserTableModel[], user) => {
      const userStat: UserTableModel = {
        ...user,
        connections: 0,
        timespent: 0,
      };

      if (statistics) {
        const connection = statistics.usersConnections.find(stat => stat.userId === user.id);
        if (connection) {
          userStat.connections = connection.connectionNb;
          userStat.timespent = connection.timespent;
        }
      }

      acc.push(userStat);
      return acc;
    }, []);

    if (sortColumn && sortDirection) {
      result.sort((a, b) => {
        const valueA = get(a, sortColumn, '');
        const valueB = get(b, sortColumn, '');

        if (valueA < valueB) {
          return sortDirection === 'asc' ? -1 : 1;
        } else if (valueA > valueB) {
          return sortDirection === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return result;
  }, [users, statistics, sortColumn, sortDirection, filter]);

  return (
    <div>
      <div className="page-title">Users</div>
      <div className="users-card">
        {isLoading ? (
          <Loader />
        ) : (
          <div>
            <UserTableActions />
            <UsersDataTable users={userStats} />
          </div>
        )}
      </div>
    </div>
  );
};

export default UsersPage;
